/* eslint-disable no-undef */
import "bootstrap";
import "./store-state.js";
import "./response-status.js";
import "./helpers/breadcrumbs-helper.js";
import axios from "axios";

import "../Content/js/vendor/metisMenu.js";
import "../Content/js/vendor/jquery.slimscroll.js";
import "../Content/js/vendor/waves.js";
import "../Content/libs/contextual/contentual.js";
import "../Content/libs/bootstrap-select/bootstrap-select.min.js";
import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.js";

import "../Content/libs/jquery-steps/jquery.steps.min.js";
//import '../Content/js/pages/form-wizard.init.js';
//import '../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.js';
import "../Content/libs/contextual/contentual.js";
import "../Content/libs/rwd-table/rwd-table.min.js";
import "../Content/libs/imageviewer/imageviewer.min.js";

//js helpers
import "./helpers/side-menu-link-helper.js";
import "./helpers/side-menu-helper.js";
import "./utils/casting-utilities.js";
import "./helpers/currency-helper.js";
import "./helpers/array-helper.js";
import "./helpers/roundingValue-helper.js";
import "./helpers/tooltip-helper.js";
import "./helpers/pageTitle-helper.js";
import "./helpers/contentType-helper.js";
import "./helpers/role-helper.js";
import "./helpers/order-helper.js";
//import "./helpers/file-helper.js";
import "./helpers/permissions-helper.js";
import "./helpers/httpResponseCode-helper.js";
import "./helpers/apiResponseHandler-helper.js";
//import "./helpers/siteManagementResponseCodes-helper.js";
import "./helpers/controls/dataTable-helper.js";
import "./helpers/localStorageCache-helper.js";

//services
import "./services/heartbeat-service.js";
import "./services/order-service.js";
import "./services/security-service.js";
import "./services/customer-service.js";
import "./services/customerCredits-service.js";
import "./services/system-service.js";
import "./services/notification-service.js";
import "./services/exTank-service.js";
import "./services/product-service.js";

import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "../Content/libs/bootstrap-select/bootstrap-select.min.css";
import "../Content/scss/icons.scss";

// import "../Content/fonts/Segeo/segeoFont.css";
import "../Content/fonts/HumanSans/humanSans.css";
import "../Content/scss/app.scss";
import "../Content/style.css";

//import "../Content/scss/_variables.scss";
//import * as echarts from "echarts";
//import "../Content/libs/echarts/theme.js";

import { vMaska } from "maska";

//vue plugins
import { createRouter, createWebHashHistory } from "vue-router";

window.axios = axios;
window.moment = moment;
//window.echarts = echarts;

import TestComponent from "./components/test/test.vue";

import LoadingSpinner from "./components/controls/loadingSpinner/LoadingSpinner.vue";
import DataTable from "./components/controls/dataTable/DataTable.vue";
import DatePicker from "./components/controls/datePicker/DatePicker.vue";
import SuccessModal from "./components/controls/successModal/SuccessModal.vue";
import ErrorModal from "./components/controls/errorModal/ErrorModal.vue";
import BootstrapSelect from "./components/controls/bootstrapSelect/BootstrapSelect.vue";
import ModalForm from "./components/controls/modalForm/ModalForm.vue";
import ModalMessage from "./components/controls/modalMessage/ModalMessage.vue";
import ActiveInactiveRadioButtons from "./components/controls/activeInactiveRadioButtons/ActiveInactiveRadioButtons.vue";
import FromDateToDatePickers from "./components/controls/fromDateToDatePickers/FromDateToDatePickers.vue";
import MarkAsActiveInactiveModal from "./components/controls/markAsActiveInactiveModal/MarkAsActiveInactiveModal.vue";
import CurrencyInput from "./components/controls/currencyInput/CurrencyInput.vue";
import PasswordUpdateModal from "./components/controls/passwordUpdateModal/PasswordUpdateModal.vue";
import EmailQueryModal from "./components/controls/emailQueryModal/EmailQueryModal.vue";

//vehicle management components
import CustomerVehicles from "./components/vehicleManagement/CustomerVehicles/CustomerVehicles.vue";
import PeopleToNotify from "./components/vehicleManagement/CustomerVehicles/peopleToNotify/PeopleToNotify.vue";

import OrdersDeliveryDashboard from "./components/Dashboard/OrdersDeliveryDashboard/OrdersDeliveryDashboard.vue";
import OrdersCollectionDashboard from "./components/Dashboard/OrdersCollectionDashboard/OrdersCollectionDashboard.vue";
import OrdersExTankDashboard from "./components/Dashboard/OrderExTankDashboard/OrderExTankDashboard.vue";

import AddressBook from "./components/addressBook/AddressBook.vue";

import TransactionHistory from "./components/transactionHistory/TransactionHistory.vue";

import UserManagement from "./components/userManagement/UserManagement.vue";

import DeliveryOrders from "./components/orders/deliveryOrders/DeliveryOrders.vue";
import ViewOrder from "./components/orders/viewOrder/ViewOrder.vue";

import CollectionOrders from "./components/orders/collectionOrders/CollectionOrders.vue";
import ViewOrderCollection from "./components/orders/viewCollectionOrder/ViewOrderCollection.vue";

import DocumentsManagement from "./components/DocumentsManagement/DocumentsManagement.vue";

//common order components
import CreateDeliveryOrderModal
	from "./components/orders/deliveryCommon/createDeliveryOrderModal/CreateDeliveryOrderModal.vue";
import ShippingAddressForOrder
	from "./components/orders/deliveryCommon/shippingAddressSelectForOrder/ShippingAddressForOrder.vue";
import ProductSelectForOrder from "./components/orders/deliveryCommon/productSelectModal/ProductSelectForOrder.vue";
import TrackingHistoryModal from "./components/orders/common/trackingHistoryModal/TrackingHistoryModal.vue";
import OrderItemsTable from "./components/orders/common/orderItemsTable/OrderItemsTable.vue";
import SelectShippingAddressForOrderModal
	from "./components/orders/deliveryCommon/selectShippingAddressForOrderModal/SelectShippingAddressForOrderModal.vue";
import OrderDocumentsModal from "./components/orders/common/OrderDocumentsModal/OrderDocumentsModal.vue";
import OrderEnquiryMessages from "./components/orders/OrderEnquiryMessages/OrderEnquiryMessages.vue";

//common collection orders
import CreateCollectionOrderModal from "./components/orders/collectionCommon/createCollectionOrderModal/CreateCollectionOrderModal.vue";
import ProductSelectCollectionOrder
	from "./components/orders/collectionCommon/productSelectCollectionOrder/ProductSelectCollectionOrder.vue";

import LogsTable from "./components/Dashboard/controls/logsTable/LogsTable.vue";
import Dashboard from "./components/Dashboard/Dashboard.vue";
import AccountInformation from "./components/AccountInformation/AccountInformation.vue";

import FindDepot from "./components/findDepot/FindDepot.vue";

// ex-tank orders
import ExTankOrderManagement from "./components/orders/ExTankOrderManagement/ExTankOrderManagement.vue";
import AddOrUpdateExTankOrderModal
	from "./components/orders/ExTankOrderManagement/common/AddOrUpdateExTankOrderModal/AddOrUpdateExTankOrderModal.vue";
import ViewExTankOrder from "./components/orders/ExTankOrderManagement/ViewExTankOrder/ViewExTankOrder.vue";

import ProductSelectForExTankOrder
	from "./components/orders/ExTankOrderManagement/common/ProductSelectForExTankOrder/ProductSelectForExTankOrder.vue";
import UploadBolModal from "./components/orders/ExTankOrderManagement/common/UploadBolModal/UploadBolModal.vue";

import CustomerSpecialPricing from "./components/customerSpecialPricing/CustomerSpecialPricing.vue";
import CustomerGroupPricingForZoneExTank
    from "./components/customerSpecialPricing/exTank/CustomerGroupPricingForZoneExTank/CustomerGroupPricingForZoneExTank.vue";
import CustomerGroupPricingForZone
    from "./components/customerSpecialPricing/delivery/customerGroupPricingForZone/CustomerGroupPricingForZone.vue";
import CustomerDiscountGroupsManagement
    from "./components/customerSpecialPricing/collection/customerDiscountGroupsManagement/CustomerDiscountGroupsManagement.vue";
import CustomerDepotDiscountGroupsManagement
    from "./components/customerSpecialPricing/collection/customerDepotDiscountGroupsManagement/CustomerDepotDiscountGroupsManagement.vue";
import ViewCustomerGroupPricingForZone
    from "./components/customerSpecialPricing/delivery/viewCustomerGroupPricingForZone/ViewCustomerGroupPricingForZone.vue";

import ViewCustomerGroupPricingPerZoneExTank
    from "./components/customerSpecialPricing/exTank/ViewCustomerGroupPricingPerZoneExTank/ViewCustomerGroupPricingPerZoneExTank.vue";

import ZonePricingForCustomerAddOrUpdateTable
    from "./components/customerSpecialPricing/exTank/common/zonePricingForCustomerAddOrUpdateTable/ZonePricingForCustomerAddOrUpdateTable.vue";

import { createApp } from "vue";
import VueGoogleMaps from 'vue-google-maps-community-fork';
//import VueGoogleMaps from '@fawmi/vue-google-maps';

let options = {
	data() {
		return {
			sharedState: storeState.state,
			breadcrumbs: [],
			maxBreadcrumbs: 3,
			breadcrumbsSessionKey: "breadcrumbs",
			isRefreshed: true,
			breadcrumbState: breadcrumbsStoreState.breadcrumbsState,
			//hideTitleBar: false,
			welcomePageReplacedInNavigationHistory: false,
			shouldReplaceUrl: true,
			creditBalance: null
		};
	},
	methods: {
		navigateToNewRoot(route){
			if(!this.welcomePageReplacedInNavigationHistory){
				this.$router.replace(route);
				this.welcomePageReplacedInNavigationHistory = true;
			}
			else{
				this.$router.push(route);
			}
		},
		determineIfMenuItemsShouldReplaceUrl(){
			if (window.location.hash === "#/"){
				this.shouldReplaceUrl = true;
			}
			else{
				this.shouldReplaceUrl = false;
			}
		},
		getCreditBalance(){
			customerCreditsService.getCurrentCompanyCreditByCompany(this.companyId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.result === null){
							this.creditBalance = currencyHelper.numberToCurrency(0);
						}
						else{
							this.creditBalance = currencyHelper.numberToCurrency(successResponse.data.result.currentBalance);
						}
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	components: {
	},
	mounted: function () {
		//this.loadBreadcrumbs();
		this.getCreditBalance();
		permissionsHelper.getPermissions(false, false);
		let hasLoggedIn = false;
		let hasLoggedSession = sessionStorage.getItem("hasLoggedInSession");
		if(hasLoggedSession !== null){
			hasLoggedIn = castingUtility.toBoolean(hasLoggedSession);
		}
		else{
			sessionStorage.setItem("hasLoggedInSession", "true");
		}
		if(!hasLoggedIn){
			// permissionsHelper.getPermissions(false, false);
			let menuItems = document.getElementById("side-menu").querySelectorAll("li > a");
			for(let i = 0; i < menuItems.length; i++){
				if(!menuItems[i].classList.contains("menuItemLink")){
					let newHomeRoute = menuItems[i].hash.replace("#", "");
					this.$router.replace(newHomeRoute);
					break;
				}
			}
		}
		breadcrumbsStoreState.loadBreadcrumbs();
		setTimeout(function (){
			sideMenuLinksHelper.updateActiveLinks();
		}, 100);
	},
	watch: {
		'$route':{
			handler: function(){
				console.log("route app js", this.$route);
				permissionsHelper.setCurrentRoute(this.$route);
			},
			immediate: true,
			deep: true
		},
		breadcrumbState:{
			handler: function(){
				this.breadcrumbs = breadcrumbsStoreState.getBreadcrumbsToDisplay();
			},
			immediate: true,
			deep: true
		}
	}
};

const app = createApp(options).directive("maska", vMaska);

app.component("test", TestComponent);
app.component("loading-spinner", LoadingSpinner);
app.component("logs-table", LogsTable);
app.component("data-table", DataTable);
app.component("date-picker", DatePicker);
app.component("success-modal", SuccessModal);
app.component("error-modal", ErrorModal);
app.component("bootstrap-select", BootstrapSelect);
app.component("modal-form", ModalForm);
app.component("modal-message", ModalMessage);
app.component("active-inactive-radio-buttons", ActiveInactiveRadioButtons);
app.component("from-date-to-date-pickers", FromDateToDatePickers);
app.component("mark-as-active-inactive-modal", MarkAsActiveInactiveModal);
app.component("currency-input", CurrencyInput);
app.component("password-update-modal", PasswordUpdateModal);
app.component("email-query-modal", EmailQueryModal);

//common orders components
app.component("create-delivery-order-modal", CreateDeliveryOrderModal);
app.component("product-select-for-order", ProductSelectForOrder);
app.component("shipping-address-for-order", ShippingAddressForOrder);
app.component("tracking-history-modal", TrackingHistoryModal);
app.component("order-items-table", OrderItemsTable);
app.component("select-shipping-address-for-order-modal", SelectShippingAddressForOrderModal);
app.component("order-documents-modal", OrderDocumentsModal);

app.component("create-collection-order-modal", CreateCollectionOrderModal);
app.component("product-select-collection-order", ProductSelectCollectionOrder);

//ex-tank orders common components
app.component("product-select-for-exTank-order", ProductSelectForExTankOrder);
app.component("add-or-update-exTank-order-modal", AddOrUpdateExTankOrderModal);
app.component("upload-bol-modal", UploadBolModal);

app.component("zone-pricing-for-customer-add-update-table", ZonePricingForCustomerAddOrUpdateTable);

app.component("customer-group-pricing-for-zone-component", CustomerGroupPricingForZone);
app.component("customer-group-pricing-for-zone-ex-tank", CustomerGroupPricingForZoneExTank);
app.component("customer-discount-groups-management-component", CustomerDiscountGroupsManagement);
app.component("customer-depot-discount-groups-management-component", CustomerDepotDiscountGroupsManagement);

//global filters
app.config.globalProperties.$filters = {
	dateShortForm(date, showTime) {
		if(showTime){
			// eslint-disable-next-line no-undef
			return moment(date).format("DD MMM YYYY HH:mm");
		}
		// eslint-disable-next-line no-undef
		return moment(date).format("DD MMM YYYY");
	},
    dateLongForm(date, showTime) {
        if(showTime){
            // eslint-disable-next-line no-undef
            return moment(date).format("dddd, DD MMMM YYYY HH:mm");
        }
        // eslint-disable-next-line no-undef
        return moment(date).format("dddd, DD MMMM YYYY");
    },
    dateDefaultStandard(date, showTime) {
        if(showTime){
            // eslint-disable-next-line no-undef
            return moment(date).format("DD/MM/YYYY HH:mm");
        }
        // eslint-disable-next-line no-undef
        return moment(date).format("DD/MM/YYYY");
    }
};
app.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyCGAH9fut53QSMCbZUDkwnzKENDFCRofEs',
		libraries: 'places',
	},
})
if (document.getElementById("spa-page")){
	const routes = [
		{ 
			path: "/", 
			component: Dashboard
		},
		{
			path: "/dashboard/ordersCollectionDashboard",
			component: OrdersCollectionDashboard
		},
		{
			path: "/dashboard/ordersDeliveryDashboard",
			component: OrdersDeliveryDashboard
		},
		{
			path: "/dashboard/ordersExTankDashboard",
			component: OrdersExTankDashboard
		},
		{
			path: "/addressBook",
			component: AddressBook
		},
		{
			path: "/transactionHistory",
			component: TransactionHistory
		},
		{
			path: "/vehicleManagement",
			component: CustomerVehicles
		},
		{
			path: "/vehicleManagement/peopleToNotify/:vehicleId",
			component: PeopleToNotify,
			props: true
		},
		{
			path: "/orders/delivery",
			component: DeliveryOrders
		},
		{
			path: "/orders/viewOrder/:orderId?/:orderDeliveryId?",
			component: ViewOrder,
			props: true
		},
		{
			path: "/orders/collection",
			component: CollectionOrders
		},
		{
			path: "/orders/collection/viewOrder/:orderId?/:orderCollectionId?",
			component: ViewOrderCollection,
			props: true
		},
		{
			path: "/orders/extank",
			component: ExTankOrderManagement
		},
		{
			path: "/orders/extank/viewOrder/:orderExTankId?/:orderId?",
			component: ViewExTankOrder,
			props: true
		},
		{
			path: "/orders/orderEnquiryMessages/:orderId?/:orderTypeId?/:orderStatusId?",
			component: OrderEnquiryMessages,
			props: true
		},
		{
			path: "/accountInformation", 
			component: AccountInformation
		},
		{
			path: "/userManagement",
			component: UserManagement
		},
		{
			path: "/findDepot",
			component: FindDepot
		},
		{
			path: "/documents",
			component: DocumentsManagement
		},
        {
            path: "/pricing",
            component: CustomerSpecialPricing
        },
        {
            path: "/pricing/viewCustomerGroupPricingForZone",
            component: ViewCustomerGroupPricingForZone
        },
        {
            path: "/pricing/extank/viewCustomerGroupPricingForZoneExTank/:productId",
            component: ViewCustomerGroupPricingPerZoneExTank,
            props: true
        }
	];

	const router = createRouter({
		history: createWebHashHistory(),
		//history: createWebHistory('Portal/Home'),
		routes, // short for `routes: routes`
	});
	app.use(router);
}

if (document.getElementById("app")) {
	//load vue js options on specific pages
	// app.use(VueGoogleMaps, {
	// 	load: {
	// 		key: 'AIzaSyCGAH9fut53QSMCbZUDkwnzKENDFCRofEs',
	// 		// language: 'de',
	// 	},
	// }).mount("#app");
	app.mount("#app");
}



